import {
  IonIcon,
  IonImg,
  IonItem,
  IonList,
  IonMenu,
  IonMenuToggle,
} from "@ionic/react";

import { useHistory, useLocation } from "react-router-dom";
import {
  calendarOutline,
  calendar,
  peopleOutline,
  people,
  fileTrayFullOutline,
  fileTrayFull,
  logOutOutline,
  logOut,
  gridOutline,
  grid,
  logoWhatsapp,
  peopleCircleOutline,
  peopleCircle,
  globeOutline,
  globe,
} from "ionicons/icons";
import "./Menu.css";
import { useEffect, useState } from "react";
import ModalPacienteForm from "../ModalFormPaciente/ModalFormPaciente";
import { Link, Typography } from "@mui/joy";
import { Column, Row } from "../../basicsComponents/MaterialGridComponents";
import { createOutline } from "ionicons/icons";

const appPages = [
  {
    title: "Inicio",
    url: "/portal/Inicio",
    iosIcon: gridOutline,
    mdIcon: grid,
  },
  {
    title: "Reservar Turno",
    url: "/portal/Reservar turno",
    iosIcon: peopleCircleOutline,
    mdIcon: peopleCircle,
  },
  {
    title: "Horarios Prestadores",
    url: "/portal/Horarios",
    iosIcon: peopleOutline,
    mdIcon: people,
  },
  {
    title: "Mis Turnos",
    url: "/portal/Turnos",
    iosIcon: calendarOutline,
    mdIcon: calendar,
  },
  {
    title: "Mis Estudios",
    url: "/portal/Estudios",
    iosIcon: fileTrayFullOutline,
    mdIcon: fileTrayFull,
  },
];

const Menu = () => {
  const location = useLocation();
  const [usuario, setUsuario] = useState({});
  const [openModalPaciente, setOpenModalPaciente] = useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir === true) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const history = useHistory();
  useEffect(() => {
    try {
      setUsuario(JSON.parse(sessionStorage.getItem("ppUL")));
    } catch {
      history.push({ pathname: "/ErrorPage" });
    }
  }, []);

  useEffect(() => {
    if (usuario.nombre !== "") {
      if (history.location.state?.justLogin === true) {
        history.location.state = {};
        setOpenModalPaciente(true);
      }
    }
  }, [usuario, history]);

  return (
    <IonMenu contentId="main" type="overlay">
      <div className="menu-layout">
        <div className="menu-scroll-container">
          <Row container className="menu-main-content">
            <IonImg
              src="assets/logo.png"
              // style={{ backgroundColor: "#009cc4", padding: "12px" }}
            />
            <div
              onClick={() => setOpenModalPaciente(true)}
              style={{
                cursor: "pointer",
              }}
            >
              <Typography
                level="title-lg"
                className="encabezado"
                sx={{ color: "#386f8a" }}
              >
                {usuario.apellido}, {usuario.nombre}
              </Typography>
              <Typography
                level="title-md"
                className="encabezado"
                sx={{ color: "#386f8a" }}
              >
                {usuario.email}
                <IonIcon
                  icon={createOutline}
                  style={{
                    fontSize: "24px",
                    color: "#64d448",
                    marginLeft: "10px",
                  }}
                />
              </Typography>
            </div>
            <IonList id="inbox-list" style={{ marginTop: "7.5px" }}>
              {appPages.map((appPage, index) => {
                return (
                  <IonMenuToggle key={index} autoHide={false}>
                    <IonItem
                      className={
                        location.pathname === appPage.url ? "selected" : ""
                      }
                      routerLink={appPage.url}
                      routerDirection="none"
                      lines="none"
                      detail={false}
                    >
                      <IonIcon
                        aria-hidden="true"
                        slot="start"
                        ios={appPage.iosIcon}
                        md={appPage.mdIcon}
                      />
                      <Typography
                        sx={{
                          color:
                            location.pathname === appPage.url
                              ? "#386f8a"
                              : "#000",
                        }}
                        level={
                          location.pathname === appPage.url
                            ? "title-md"
                            : "title-sm"
                        }
                      >
                        {appPage.title.toUpperCase()}
                      </Typography>
                    </IonItem>
                  </IonMenuToggle>
                );
              })}
              <IonItem button lines="none" className="amarillo-sol">
                <IonIcon slot="start" icon={logoWhatsapp} />
                <Typography level={"title-sm"}>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={
                      "https://api.whatsapp.com/send?phone=+5493513455853&text=Hola%2C%20me%20ponía%20en%20contacto%20para%20registrarme%20como%20paciente."
                    }
                  >
                    {`Nuestro Whatsapp`.toUpperCase()}
                  </a>
                </Typography>
              </IonItem>
              <IonItem button lines="none" routerLink={"/"}>
                <IonIcon
                  aria-hidden="true"
                  color="solid"
                  slot="start"
                  ios={logOutOutline}
                  md={logOut}
                />
                <Typography variant="title-sm" color="danger">
                  {`Cerrar Sesion`.toUpperCase()}
                </Typography>
              </IonItem>
            </IonList>
          </Row>
        </div>

        <div className="menu-footer">
          <Row container justifyContent="center" alignItems="center">
            <Column container justifyContent="space-between" alignItems="center">
              <Link
                href="https://www.gacitua.com.ar/"
                rel="Proveedor del servicio noreferrer"
                target="_blank"
              >
                <Typography level="title-lg">
                  <Typography color="neutral"> {"Powered by "}</Typography>
                  <img
                    src={"assets/logoGacitua.png"}
                    alt="logo gacitua y asociados"
                    width={17}
                    height={17}
                  />
                  <Typography> {" Gacitua y asociados"}</Typography>
                </Typography>
              </Link>
            </Column>
          </Row>
        </div>
      </div>

      <ModalPacienteForm
        openModal={openModalPaciente}
        setOpenModal={setOpenModalPaciente}
        mostrarNotificacion={mostrarNotificacion}
        paciente={usuario}
      />
    </IonMenu>
  );
};

export default Menu;
